import { compose } from "@reduxjs/toolkit";
import { Col, Divider, List, Row, Skeleton, Tag, message } from "antd";
import dayjs from 'dayjs';
import i18next from "i18next";
import Lottie from "lottie-react";
import React from "react";
import NoDataFoundAnimation from '../../animate-lottie/lottie-not-data-found.json';
import { MainTitle, NJVCard } from "../../components/core-component";
import { Constant } from "../../core/constant";
import Api from "../../network/api";
import { HTTP_METHOD } from "../../network/httpMethod";
import { MEDIA_TYPE } from "../../network/mediaType";
import { ApiHandler } from "../../network/network-manager";
import withRouter from "../../network/with-router";
import CustomPath from "../../routes/custom-path";
import Theme from "../../components/theme";

class RTSOrderPage extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            data: [],
            order_history_collection: [],
            historyMap: {},
            titleList: [],
            isDataFetching: true,
            totalPage: 0,
            pageSize: Constant.pageSize,
            page: 1,
            filterData: {},
            orders_status_list: []
        }
    }

    componentDidMount() {
        this.fetchData()
        this.fetchOrderStatus()
    }

    fetchOrderStatus = async () => {
        try {
            var requestParams = {
                'enumType': 'ORDER_STATUS'
            }
            const response = await ApiHandler({ url: Api.enum_filter, method: HTTP_METHOD.GET, mediaType: MEDIA_TYPE.JSON, requestParams })
            if (response) {
                let temp = []
                response.map((res) => {
                    temp.push({
                        value: res.key,
                        label: res.value,
                    });
                })
                this.setState({
                    orders_status_list: temp
                })
            }
        } catch (error) {
        }
    }

    routeToOrderDetail = (trackingNumber, id) => {
        const data = {
            id: trackingNumber,
            rts_id: id
        }
        this.props.navigate(
            CustomPath.rts_order_detail,
            { state: { data: data } }
        );
    }

    fetchData = async (pageNumber) => {
        let { pageSize, page, filterData } = this.state
        try {
            this.setState({
                isDataFetching: true
            })
            let params = {
                page: pageNumber ? pageNumber - 1 : page - 1,
                size: pageSize
            }
            if (filterData) {
                if ((filterData.fromDate && !filterData.toDate) || (!filterData.fromDate && filterData.toDate)) {
                    message.error("Invalid date")
                    return
                }
                if (filterData.fromDate > filterData.toDate) {
                    message.error("Invalid date")
                    return
                }

                if (filterData.fromDate) {
                    filterData = { ...filterData, 'fromDate': filterData.fromDate.format("YYYY-MM-DD") }
                }
                if (filterData.toDate) {
                    filterData = { ...filterData, 'toDate': filterData.toDate.format("YYYY-MM-DD") }
                }
                if (filterData.recipientPhoneNumber) {
                    const updatedValue = filterData.recipientPhoneNumber.charAt(0) === '0' ? filterData.recipientPhoneNumber.slice(1) : filterData.recipientPhoneNumber;
                    filterData = { ...filterData, recipientPhoneNumber: updatedValue }
                }

                params = {
                    ...params,
                    ...filterData
                }
            }

            const response = await ApiHandler({ url: Api.order_rts_shipper, method: HTTP_METHOD.GET, mediaType: MEDIA_TYPE.JSON })
            if (response) {
                let newList = []
                response.map(rts_order => {
                    if (rts_order.responseTimeLeft) {
                        const responseTimeLeft = dayjs(rts_order.responseTimeLeft, 'YYYY-MM-DD HH:mm:ss');
                        rts_order = { ...rts_order, responseTimeLeft: responseTimeLeft.format('DD MMM, YYYY hh:mm A') }
                    }
                    newList.push(rts_order)
                })
                this.setState({
                    data: newList
                })
            }
        } catch (error) {
        }
        this.setState({
            isDataFetching: false
        })
    }

    search = () => {
        this.fetchData(null)
    }

    updateFilterData = (key, value) => {
        let { filterData } = this.state
        filterData = {
            ...filterData,
            [key]: value
        }
        this.setState({
            filterData: filterData
        })
    }
    pagination = (page, size) => {
        this.fetchData(page)

    }
    render() {
        const { isDataFetching, data } = this.state
        return (
            <Row>
                <Col span={24}>
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <MainTitle label={i18next.t("rts")} />
                        </Col>
                        <Col span={24}>
                            {
                                isDataFetching ?
                                    <Skeleton active />
                                    :
                                    <>
                                        {
                                            data && data.length !== 0 ?
                                                <List
                                                    itemLayout="horizontal"
                                                    dataSource={data}
                                                    renderItem={(item, index) => (
                                                        <NJVCard
                                                            style={{
                                                                paddingBottom: 10,
                                                                paddingTop: 10,
                                                                marginBottom: 10,
                                                                borderRadius: 20,
                                                                width: '100%',
                                                                cursor: 'pointer'
                                                            }}
                                                            bordered={false}
                                                            onClick={() => this.routeToOrderDetail(item.order.trackingNumber, item.id)}
                                                        >
                                                            <Row>
                                                                <Col lg={19} xl={19} xs={0} sm={0}>
                                                                    <div style={{
                                                                        fontSize: 17,
                                                                        fontWeight: '600'
                                                                    }}>{item.order.trackingNumber}</div>
                                                                    <div>{item.order.recipientName}</div>
                                                                    <div>{item.order.recipientPhoneNumber}</div>
                                                                </Col>
                                                                <Col lg={5} xl={5} xs={0} sm={0} style={{ textAlign: 'right' }}>
                                                                    <div>Response Before</div>
                                                                    <div>{item.responseTimeLeft}</div>
                                                                </Col>
                                                                {/* {
                                                                    item.failReason && <Col lg={24} xl={24} xs={0} sm={0}>
                                                                        <Divider />
                                                                        <div><Tag color={Theme.colors.default}>{i18next.t("reason")}</Tag> {item.failReason}</div>
                                                                    </Col>
                                                                } */}

                                                                <Col lg={0} xl={0} xs={24} sm={24}>
                                                                    <div style={{
                                                                        fontSize: 17,
                                                                        fontWeight: '600'
                                                                    }}>{item.order.trackingNumber}</div>
                                                                    <div>{item.order.recipientName}</div>
                                                                    <div>{item.order.recipientPhoneNumber}</div><br />
                                                                    <div>Response Before : {item.responseTimeLeft}</div>
                                                                </Col>
                                                                {/* {
                                                                    item.failReason && <Col lg={0} xl={0} xs={24} sm={24}>
                                                                        <Divider />
                                                                        <div><Tag color={Theme.colors.default}>{i18next.t("reason")}</Tag> {item.failReason}</div>
                                                                    </Col>
                                                                } */}
                                                            </Row>
                                                        </NJVCard>
                                                    )}
                                                />
                                                :
                                                <Row style={{ borderRadius: 11, paddingBottom: 30, background: '#fff' }}>
                                                    <Col span={24} style={{ display: 'flex', justifyContent: 'center' }}>
                                                        <Lottie
                                                            style={{ height: '200px' }}
                                                            animationData={NoDataFoundAnimation}
                                                            loop={true}
                                                            autoplay={true}
                                                        />
                                                    </Col>
                                                    <Col span={24} style={{ textAlign: 'center' }}>
                                                        <div style={{ fontSize: 16, fontWeight: '600', marginBottom: 10, color: '#808080' }}>
                                                            {i18next.t("no_notification_yet")}
                                                        </div>
                                                        <div style={{ fontSize: 16, color: '#808080' }}>
                                                            {i18next.t("msg_notification")}
                                                        </div>
                                                    </Col>
                                                </Row>

                                        }
                                    </>
                            }
                        </Col>
                    </Row>
                    <Row>

                    </Row>
                </Col >
            </Row >
        )
    }
}

export default compose(withRouter)(RTSOrderPage);